import { createContext, ReactNode, useContext } from 'react';
import { Sector } from '@kiwicom/openapi-sdk/mmb';
import { ThrowAwayBannerAction } from '../types';

type ItineraryContextShape = {
  throwAwaySectors: Sector[] | undefined;
  throwAwayBannerAction: ThrowAwayBannerAction;
  tatModalDescription: ReactNode;
};

/**
 * This context stores objects and properties which are required throughout the Itinerary. It's used to avoid prop drilling
 * the objects through the whole component tree.
 *
 * @param throwAwaySectors - Sectors, which are not displayed in the Itinerary but shown in the {@link ThrowAwayTicketModal}.
 * @param throwAwayBannerAction - Action which should be performed after the user clicks on the ThrowAwayBanner.
 */
export const ItineraryContext = createContext<ItineraryContextShape>({
  throwAwaySectors: undefined,
  throwAwayBannerAction: ThrowAwayBannerAction.showModal,
  tatModalDescription: null,
});

export const useItineraryContext = (): ItineraryContextShape => useContext(ItineraryContext);
